<template>
  <v-row
    align="center"
    :justify="justify"
  >
    <tc-v-btn
      v-if="rewardLink"
      id="back-button"
      color="primary"
      text
      exact
      :to="{ name: catalogRoute }"
      class="mt-8"
    >
      <v-icon>
        mdi-chevron-left
      </v-icon>
      <span
        :aria-label="$t('aria-label-global-button-back')"
        class="text-capitalize"
      >
        {{ $t('global-button-back') }}
      </span>
    </tc-v-btn>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_REWARD_LINK } from '../../store/get-types'
import { CATALOG_ROUTE } from '@/router/routes/route-names'

export default {
  name: 'BackButton',
  props: {
    justify: {
      type: String,
      default: 'center'
    }
  },
  computed: {
    ...mapGetters({
      rewardLink: GET_REWARD_LINK
    }),
    catalogRoute () {
      return CATALOG_ROUTE
    }
  }
}
</script>
